<template lang="html">
    <div class="all-wrap">
        <nav-header v-bind:showSearch="p_showSearch" v-bind:loginModalFlag="p_loginModalFlag" v-on:showLoginModal="p_showLoginModal" v-on:closeLoginModal="p_closeLoginModal"></nav-header>
        <nav-bread ref="child"></nav-bread>
        <div class="medicines">
          <p class="title">药品</p>
          <p class="subTitle" @click="gotoHome">全部商品</p>
        </div>
        <div class="medicine-wrap">
            <div class="medicine-name">
                {{medList[id].name}}
            </div>
            <div class="introduction">
                <img :src="medList[id].src" alt="">
                <div class="content">
                	<h2>
                		{{medList[id].name}}
                    </h2>
        	        <strong>产品应用</strong>
                	<p>
                        {{medList[id].application}}
                    </p>
        	        <strong>药品简介</strong>
                	<p>
                		{{medList[id].ingredients}}
                    </p>
                    <strong>适用病症</strong>
                	<p>
                		{{medList[id].functions}}
                    </p>
                	<p>
                        {{medList[id].ingredients}}
                    </p>
        	        <strong>用法用量</strong>
                	<p>
                		{{medList[id].usage}}
                    </p>
        	        <strong>不良反应</strong>
                	<p>
                        {{medList[id].reactions}}
                    </p>
        	        <strong>注意事项</strong>
        	        <p>
                        {{medList[id].cautions}}
                    </p>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import axios from 'axios'
import "./../../assets/css/base.css";
import "@/assets/css/product.css";
import "@/assets/css/index.css?version=1.0.1";
import NavHeader from "@/components/Header.vue";
import NavFooter from "@/components/Footer.vue";
import NavBread from "@/components/Bread.vue";
import {getCookie} from "@/util/util.js"
import 'babel-polyfill'

import {medicinesData} from '@/util/medicines.js'

export default {
    name: "medicine",
    components: {
      NavHeader,
      NavFooter,
      NavBread
    },
    data() {
      return {
          id: this.$route.query.id - 1,
          p_showSearch: true,
          p_loginModalFlag: false,
          hasMoreData: true,
          changes: '',
          inspectionList:[],
          cooperationLIst:[],
          providerType: this.$route.query.providerType,
          medList: medicinesData()
      }
    },
    methods: {
        gotoHome() {
            this.$router.push('/medicines')
        },
        p_showLoginModal() {
          this.p_loginModalFlag = true;
        },
        p_closeLoginModal() {
          this.p_loginModalFlag = false;
        },
        toSearch(itemName, id) {
          this.$router.push({
            path: "search",
            query: {
              id: id,
              name: itemName
            }
          });
        },

      toInsep() {
        if(getCookie("_token")){
          this.changes ="already"
        }else{
          this.p_showLoginModal()
        }
      },
    },
    computed: {
      token(){
        return getCookie("_token")?getCookie("_token"):""
      },
       user() {
        return this.$store.state.user;
      }
    },
    mounted(){
      this.changes = getCookie("_token")?"already":""
      // this.getCooperationLIst( )
      console.log(id)
    },
    watch: {
      'token': function(newVal){
        this.changes = newVal?"already":""
      }
    }
}
</script>

<style lang="css" scoped>
.medicine-wrap {
    width: 71%;
    margin: 0 auto;
    border: 1px solid #ccc;
    margin-top: 5px;
    padding: 14px 20px;
}

.medicines {
    width: 75%;
    padding: 0 10px;
    margin: 0 auto;
    margin-top: 28px;
}

.medicines p {
    color: #605F5F;
    box-sizing: border-box;
}

.medicines .title {
   height: 41px;
   line-height: 40px;
   font-weight: 700;
   font-size: 17px;
   width: 50px;
   border-top: 2px solid #00C4AA;
}

.medicines .subTitle {
   height: 46px;
   line-height: 46px;
   color: #00C4AA;
   font-size: 16px;
   border-top: 2px solid #00C4AA;
   width: 100%;
   text-align: left;
   text-indent: 15px;
   font-weight: normal;
   cursor: pointer;
}

.medicines-list {
   width:100%;
   padding-bottom: 50px;
}

.medicine-name {
    height:46px;
    line-height:46px;

    text-align:center;
    font-size:14px;
    color:#333;
    font-weight: bold;
    border: 1px solid #E5E5DE;
    box-shadow: 2px 2px 5px #E5E5DE;
}

.introduction img {
    display: block;
    width: 150px;
    height: 150px;
    background-color: pink;
    margin: 14px 0;
}

.content {
    text-align: left;
    line-height: 25px;
}

.content h2, .content strong {
    font-weight: bold;
    margin-bottom: 6px;
}

.content p {
    font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// src/pages/medicines/medicine.vue